import React from 'react';
import { motion } from 'framer-motion';
import Card from './Card';

interface CompactFeatureCardProps {
  icon?: React.ReactNode;
  title: string;
  description: string;
  delay?: number;
}

/**
 * Compact feature card optimized for service pages with clean spacing
 */
const CompactFeatureCard: React.FC<CompactFeatureCardProps> = ({
  icon,
  title,
  description,
  delay = 0,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay }}
      className="h-full"
    >
      <Card className="h-full p-6 hover:shadow-lg transition-shadow duration-200">
        {icon && (
          <div className="w-12 h-12 mb-4 bg-primary/10 rounded-lg flex items-center justify-center text-primary">
            {icon}
          </div>
        )}
        <h3 className="text-lg font-semibold mb-3">{title}</h3>
        <p className="text-neutral-600 text-sm leading-relaxed">{description}</p>
      </Card>
    </motion.div>
  );
};

export default CompactFeatureCard;